import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const AddNew = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16 1.59998V30.4M30.4 16H1.60001", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default AddNew;
